import React from "react";
import * as THREE from "three";
import { BufferGeometryUtils } from "three/examples/jsm/utils/BufferGeometryUtils.js";

export const colors = {
  "01": [255, 255, 255],
  "02": [0, 0, 0],
  "04": [240, 168, 98],
  "05": [237, 201, 178],
  "06": [117, 85, 63],
  "07": [153, 145, 139],
  "08": [153, 145, 139],
  "09": [64, 102, 46],
  10: [94, 57, 21],
  11: [201, 201, 201],
};

const getMeshFromModel = (model) => {
  const geometries = [];

  for (let y = 0; y < model.length; y++) {
    const stack = model[y];
    for (let z = 0; z < stack.length; z++) {
      const line = stack[z];
      for (let x = 0; x < line.length; x++) {
        const block = line[x];
        if (block !== "00" && block !== "03") {
          const geometry = new THREE.BoxGeometry(1, 1, 1);
          geometry.applyMatrix4(new THREE.Matrix4().makeTranslation(x, y, z));

          const rgb = colors[block];
          const numVerts = geometry.getAttribute("position").count;
          const itemSize = 3; // r, g, b
          const colorsArray = new Uint8Array(itemSize * numVerts);

          // copy the color into the colors array for each vertex
          colorsArray.forEach((v, ndx) => {
            colorsArray[ndx] = rgb[ndx % 3];
          });

          const colorAttrib = new THREE.BufferAttribute(colorsArray, 3, true);

          geometry.setAttribute("color", colorAttrib);

          geometries.push(geometry);
        }
      }
    }
  }

  const mergedFullGeometry = BufferGeometryUtils.mergeBufferGeometries(
    geometries,
    false
  );

  const mesh = (
    <mesh receiveShadow geometry={mergedFullGeometry}>
      <meshStandardMaterial attach="material" vertexColors={true} />
    </mesh>
  );

  return mesh;
};

export default getMeshFromModel;
